import type {PartiallyOptional, PartiallyRequired} from "@wix/devzai-utils-common";
import {
    DoppeActionLayout,
    doppeListActionGetDefaultListSettings,
    doppeListActionGetDefaultSearchListSettings,
    doppeListActionGetItemClickBehaviourDefaultListSettings,
    doppeListActionGetMainDetailsDefaultSettings,
    doppeListActionListItemGetDefaultListItemSettingsMigration,
    doppeListActionListItemWithCtaButtonsMigration,
    doppeListActionListItemWithSectionsMigration,
    doppeListActionTemplateCtaButtonsSettingsDefaultValuesMigration,
    doppeListActionTemplateSectionsSettingsDefaultValuesMigration
} from "../../client-server-common";
import {
    doppeActionContentSectionSettingsDefaultValuesMigration
} from "../../client-server-common/types/doppe-action-content-sections-settings";
import {
    doppeActionCtaButtonsSettingsDefaultValuesMigration
} from "../../client-server-common/types/doppe-action-cta-buttons-settings";
import {DoppeActionTypeTestimonialsList} from "./doppe-action-type-testimonials-list";

export function doppeActionTypeTestimonialsListResolveListItemSettings(testimonial: PartiallyRequired<DoppeActionTypeTestimonialsList.TestimonialItemSettings, 'id'>) {

    const {
        ctaButtonsOverridesMap,
        customCtaButtons,
        customSections,
        sectionsOverridesMap,
        id,
        deleted,
        displayInSearch,
        enabled,
        ...restProduct
    } = testimonial;

    return {
        ...doppeListActionListItemWithCtaButtonsMigration(testimonial, false),
        ...doppeListActionListItemWithSectionsMigration(testimonial),
        ...doppeListActionListItemGetDefaultListItemSettingsMigration(testimonial.id, testimonial),
        ...restProduct as PartiallyOptional<DoppeActionTypeTestimonialsList.TestimonialItemSettings, 'sectionsOverridesMap' | 'ctaButtonsOverridesMap' | 'customCtaButtons' | 'customSections'>
    }
}

export function doppeActionTypeTestimonialsListResolveActionSettings(actionSettings: Partial<DoppeActionTypeTestimonialsList.ActionSettings>) {
    const {
        sections,
        listDataItems = [],
        ctaButtons,
        listItemTemplateCtaButtonsSettings,
        listItemTemplateSectionsSettings,
        listSearchSettings,
        ...restSettings
    } = actionSettings;

    return {
        itemShowRating: true,
        previewShowTitle: true,
        previewShowDescription: true,
        previewShowAddress: true,
        previewShowPrice: true,
        ...doppeListActionGetItemClickBehaviourDefaultListSettings(),
        ...doppeListActionGetMainDetailsDefaultSettings(),
        ...doppeListActionGetDefaultSearchListSettings(actionSettings),
        ...doppeListActionGetDefaultListSettings({
            layout: DoppeActionLayout.Column,
            listDataItems: listDataItems.map(doppeActionTypeTestimonialsListResolveListItemSettings),
        }),
        ...doppeActionContentSectionSettingsDefaultValuesMigration(actionSettings),
        ...doppeActionCtaButtonsSettingsDefaultValuesMigration(actionSettings, false),
        ...doppeListActionTemplateCtaButtonsSettingsDefaultValuesMigration(actionSettings, false),
        ...doppeListActionTemplateSectionsSettingsDefaultValuesMigration(actionSettings),
        ...restSettings
    }
}